import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ErrorBannerService } from './error-banner.service';
import { BrandService } from '../../../services/brand.service';

@Component({
  selector: 'app-error-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-banner.component.html',
  styleUrl: './error-banner.component.scss',
})
export class ErrorBannerComponent implements OnInit, OnDestroy {
  visible = false;
  phoneDisplay = '';
  phoneHref = '';

  private visibleSub: Subscription;
  private brandSub: Subscription;

  constructor(
    private errorBannerService: ErrorBannerService,
    private brandService: BrandService
  ) {}

  ngOnInit(): void {
    this.visibleSub = this.errorBannerService.visible$.subscribe(
      (v) => (this.visible = v)
    );
    this.brandSub = this.brandService.brand$.subscribe((brand) => {
      this.phoneDisplay = brand.content.introHeroPhoneDisplay;
      this.phoneHref = brand.content.introHeroPhoneHref;
    });
  }

  dismiss(): void {
    this.errorBannerService.hide();
  }

  ngOnDestroy(): void {
    this.visibleSub?.unsubscribe();
    this.brandSub?.unsubscribe();
  }
}
